module.exports = __webpack_public_path__ + "img/Ykjiehsao.40e60e6b.png";